import { Flex, Icon, Divider, Skeleton, chakra } from '@chakra-ui/react';
import millify from 'millify';
import { HiStar } from 'react-icons/hi';

import { CustomText } from '@components/Custom-text';
import { Mentor } from '@modules/auth/types';
import enterpriseIcon from 'src/assets/enterprise.svg';
import videoCameraIcon from 'src/assets/video_camera_front.svg';

interface Props {
    mentorFullProfileInfo: Mentor;
    isLoading: boolean;
}

const ProfileHighlights = ({ mentorFullProfileInfo, isLoading }: Props) => (
    <Flex
        bg="popoverHover"
        borderRadius="md"
        p="24px"
        align={{ base: 'left', md: 'center' }}
        wrap="wrap"
        justify="center"
        direction={{ base: 'column', md: 'row' }}
        gap={{ base: '16px', lg: '20px' }}
        border="1px"
        borderColor="border"
    >
        {isLoading ? (
            <>
                <Skeleton height="20px" width="100px" borderRadius="md" />
                <Divider orientation="vertical" height="20px" borderColor="purple.200" />
                <Skeleton height="20px" width="140px" borderRadius="md" />
                <Divider orientation="vertical" height="20px" borderColor="purple.200" />
                <Skeleton height="20px" width="180px" borderRadius="md" />
                <Divider orientation="vertical" height="20px" borderColor="purple.200" />
                <Skeleton height="20px" width="160px" borderRadius="md" />
            </>
        ) : (
            <>
                {/* Domain */}
                <CustomText size="md" color="mainText" weight={400} lineHeight={6}>
                    {mentorFullProfileInfo?.domain?.name ?? '-'}
                </CustomText>

                <Divider
                    orientation="vertical"
                    height="20px"
                    borderColor="purple.200"
                    display={{ base: 'none', md: 'block' }}
                />

                {/* Sessions */}
                <Flex align="center" justify={{ base: 'start', lg: 'center' }} gap={2}>
                    <img src={videoCameraIcon.src} width="24" height="24" alt="Video Camera" />
                    <CustomText size="md" color="mainText" weight={400} lineHeight={6}>
                        {mentorFullProfileInfo?.sessionsCompleted ?? 0} Sessions
                    </CustomText>
                </Flex>

                <Divider
                    orientation="vertical"
                    height="20px"
                    borderColor="purple.200"
                    display={{ base: 'none', md: 'block' }}
                />

                {/* Experience */}
                <Flex align="center" justify={{ base: 'start', lg: 'center' }} gap={2}>
                    <img src={enterpriseIcon.src} width="20" height="20" alt="Enterprise" />
                    <CustomText size="md" color="mainText" weight={400} lineHeight={6}>
                        {mentorFullProfileInfo?.totalExperience?.years ?? 0} years of experience
                    </CustomText>
                </Flex>

                <Divider
                    orientation="vertical"
                    height="20px"
                    borderColor="purple.200"
                    display={{ base: 'none', md: 'block' }}
                />

                {/* Rating */}
                <Flex align="center" gap={1}>
                    <Icon as={HiStar} color="yellow.400" width="18px" height="18px" />
                    <CustomText size="md" color="mainText" weight={400} lineHeight={6}>
                        <chakra.span color="yellow.400">
                            {mentorFullProfileInfo?.totalRating?.toFixed(1) ?? '0.0'}
                        </chakra.span>
                        <chakra.span color="mainText" ml={2}>
                            ({millify(mentorFullProfileInfo?.totalReviews ?? 0)} Reviews)
                        </chakra.span>
                    </CustomText>
                </Flex>
            </>
        )}
    </Flex>
);

export default ProfileHighlights;
